import React, { memo, useCallback } from "react";

import { AddressSearchInputTexts } from "globalConstants";

import styles from "./addressSearchInput.module.scss";
import { Button } from "components";

type EmptyLabelProps = {
	text?: string;
	showEnterManuallyBtn?: boolean;
	isManualMode?: boolean;
	onClick?: (isManualMode: boolean) => void;
};

const EmptyLabel = ({
	text,
	showEnterManuallyBtn = false,
	isManualMode = false,
	onClick,
}: EmptyLabelProps) => {
	const onClickHandler = useCallback(() => {
		onClick?.(true);
	}, [onClick]);

	return (
		<div className={styles.emptyLabelContainer}>
			<div>{text || AddressSearchInputTexts.NoMatchesFound}</div>
			{showEnterManuallyBtn && (
				<Button
					value={AddressSearchInputTexts.EnterManually}
					onClick={onClickHandler}
					variant="secondary"
					title={undefined}
					shape={undefined}
					size={undefined}
					icon={undefined}
					minWidth={undefined}
					href={undefined}
					target={undefined}
					as={undefined}
					tabIndex={undefined}
					className={undefined}
					style={undefined}
					children={undefined}
					to={undefined}
					form={undefined}
				/>
			)}
		</div>
	);
};

export default memo(EmptyLabel);
